var _g, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDollarIcon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.9,
    height: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    y: 0.044297,
    fill: "#ffffff",
    x: 5.7,
    width: 4,
    id: "Top",
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    y: 26,
    x: 5.7,
    width: 4,
    id: "Bottom",
    height: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "5.7,27 9.7,31 9.7,27 ",
    id: "Shadow"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "S",
    d: "m1.1,22.3c1.4,0.7 3.6,1.4 5.8,1.4c2.4,0 3.7,-1 3.7,-2.6c0,-1.4 -1.1,-2.3 -3.9,-3.2c-3.9,-1.4 -6.4,-3.5 -6.4,-6.9c0,-4 3.3,-7 8.8,-7c2.7,0 4.6,0.5 5.9,1.2l-1.2,4.2c-0.9,-0.5 -2.6,-1.1 -4.8,-1.1c-2.3,0 -3.4,1.1 -3.4,2.2c0,1.5 1.3,2.1 4.3,3.3c4.1,1.5 6,3.7 6,7c0,3.9 -3,7.2 -9.4,7.2c-2.7,0 -5.3,-0.7 -6.6,-1.4l1.2,-4.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dollarIcon.9950b90a.svg";
export { ForwardRef as ReactComponent };